import { useQuery } from "@tanstack/react-query";

import { fetchPromptTemplates } from "../../../data/queries/promptTemplates";
import { PRODUCTION_MODEL } from "../../../services/claude";
import { PromptTemplateScope } from "../../../types/prompt-template";
import { DEFAULT_MAX_TOKENS, DEFAULT_TEMPERATURE } from "../constants/modelDefaults";

export const useCoachingHubPrompt = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["coaching-hub-prompt"],
    queryFn: async () => {
      const response = await fetchPromptTemplates(true);
      if (response.error) {
        throw response.error;
      }

      const coachingHubTemplate = response.data?.find(
        template =>
          template.metadata.scope?.includes(PromptTemplateScope.coaching_hub) &&
          template.enabled
      );

      return coachingHubTemplate || null;
    },
    staleTime: 0
  });

  return {
    coachingLensPrompt: data?.prompt || "",
    coachingLensTitle: data?.title || "",
    coachingLensModel: data?.model_config?.model || PRODUCTION_MODEL.id,
    coachingLensTemperature: data?.model_config?.temperature ?? DEFAULT_TEMPERATURE,
    coachingLensMaxTokens: data?.model_config?.max_tokens || DEFAULT_MAX_TOKENS,
    isLoading,
    error
  };
};
